import { render, staticRenderFns } from "./LeadCard.vue?vue&type=template&id=14035b51&scoped=true&"
import script from "./LeadCard.vue?vue&type=script&lang=js&"
export * from "./LeadCard.vue?vue&type=script&lang=js&"
import style0 from "./LeadCard.vue?vue&type=style&index=0&id=14035b51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14035b51",
  null
  
)

export default component.exports